export default __webpack_public_path__ + "static/media/map.fa437226.jpg";